import bellTokens from '@amzn/meridian-tokens/base/icon/bell'
import collapseTokens from '@amzn/meridian-tokens/base/icon/collapse'
import Badge from '@amzn/meridian/badge'
import Button from '@amzn/meridian/button'
import Icon from '@amzn/meridian/icon'
import Text from '@amzn/meridian/text'
import { useBundle } from '@amzn/react-arb-tools'
import { getNotificationCount } from '@atredux/selectors/notificationSelector'
import { setNotificationModalHidden } from '@atredux/slices/notificationSlice'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { NotificationModalUtils } from '@utils/NotificationModalUtils'
import React from 'react'
import './NotificationModal.css'
import { useDispatch, useSelector } from 'react-redux'

interface INotificationModalPropsInterface {
    isNotificationModalOpen: boolean
}

export const NotificationModal = (props: INotificationModalPropsInterface) => {
    const { isNotificationModalOpen } = props
    const notificationURL: string = NotificationModalUtils.getUrl()
    // Uncomment below 3 lines for local testing and comment out above line.
    // const urlParams = new URLSearchParams(NotificationModalUtils.getUrl().split('?')[1])
    // const locale = urlParams.get('locale') || DEFAULT_LOCALE
    // const notificationURL = `https://localhost.aka.corp.amazon.com:4569/?locale=${locale}&domain=test&region=pdx&storeId=MENDEL-TST-01&storeFamily=MENDEL`

    // Shared states.
    const [bundle] = useBundle(BUNDLE_NAME)
    const notificationCount = useSelector(getNotificationCount)
    const dispatch = useDispatch()

    const onClose = () => dispatch(setNotificationModalHidden())

    return (
        <div className={ isNotificationModalOpen ? 'modal-overlay' : 'modal-overlay hidden' }>
            <div className={ isNotificationModalOpen ? 'modal' : 'modal hidden' }>
                <div className="topdiv">
                    <div className="divflex">
                        <div className="id-div-red-header">
                            <Text color="inverted" type="h200">
                                {t(bundle, 'migrated-ihm-associate-tool-heart-beat-menu-store-activities')}
                                <Icon tokens={bellTokens}>
                                    {t(bundle, 'migrated-ihm-associate-tool-heart-beat-menu-notification-count',
                                      { notificationCount })}
                                    <Badge type="theme" value={notificationCount} />
                                </Icon>
                            </Text>
                            <Button data-testid="CollapseButton" onClick={onClose} type="link" size="small">
                                <Icon className={'token'} tokens={collapseTokens} />
                            </Button>
                        </div>
                    </div>
                    {
                        notificationURL &&
                        <iframe height={'91.5%'} width={'100%'} title={'ATStatusPage'} className={'iframe'} src={notificationURL}/>
                    }
                </div>
            </div>
        </div>
    )
}
